import script from "./TrialBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./TrialBalance.vue?vue&type=script&setup=true&lang=js"

import "./TrialBalance.vue?vue&type=style&index=0&id=472baea0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-472baea0"]])

export default __exports__